/**
 * @fileoverview DELETE handler for the "/product_alerts/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import type { AllRouteEndpoints } from "../routeTypes";
import { productAlerts } from "./constants";
import type { DeleteProductAlertProps } from "./types";

const deleteProductAlertCacheKeys: AllRouteEndpoints[] = [productAlerts];

export const deleteProductAlert = reactQueryMutationAdapter(
  deleteProductAlertCacheKeys,
  ({ id }: DeleteProductAlertProps) => {
    return fetch(`/product_alerts/${id}`, "DELETE", undefined, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
